<template>
  <section
    id="cover"
    class="te-bg-java-image relative flex flex-col items-center justify-center bg-cover bg-center px-4 text-center text-white"
    style="height: 500px"
  >
    <h1 class="co-display-5 mb-4 flex items-center font-bold drop-shadow">
      <FontAwesomeIcon
        :icon="faJava"
        class="fa-fw mr-3 mt-2 hidden size-9 md:inline-block"
      />
      Javaコース
    </h1>
    <h2 class="co-display-10 mb-2 drop-shadow">
      Java Servlet/JSPでWebアプリケーションを開発しよう
    </h2>
    <div
      class="co-container-xs co-display-14 mb-6 drop-shadow"
      aria-hidden="true"
    >
      <span class="te-cover-lead">
        Java Servlet/JSPを勉強・学習してW
        <span
          class="hidden"
          :class="{ '!inline': isActive }"
        >ebアプリケーションを開発する講座。スクールではシステム開発やWeb開発に使われるJavaの技術の習得を目指します。通過率10%を突破した現役エンジニアから学べるオンラインのプログラミングスクール。1人では続かない方のためのパーソナルメンターがつくプログラミングブートキャンプ。専属のパーソナルメンターがマンツーマンでオリジナルサービスの開発までサポート。転職サポートもあります。</span>
      </span>
      <span @click="isActive = !isActive">
        <FontAwesomeIcon
          v-if="isActive"
          :icon="faChevronUp"
          class="fa-fw ml-2 inline size-3"
        />
        <FontAwesomeIcon
          v-else-if="!isActive"
          :icon="faChevronDown"
          class="fa-fw ml-2 inline size-3"
        />
      </span>
    </div>
    <TeCourseCoverTimeSpan
      :begins-at="beginsAt"
      :closes-at="closesAt"
    />
    <div class="alert mb-4 block w-auto rounded border-[#ffeeba] bg-[#fff3cd] p-2 text-center text-[#856404]">
      お申し込みを停止しております。 再開の際には改めてご案内いたします。
    </div>

    <!-- 経済産業省認定バッジ -->
    <TeCommonBadgeReskilling />
  </section>
</template>

<script lang="ts">
import TeCourseCoverTimeSpan from '~/components/Te/TeCourse/TeCourseCoverTimeSpan.vue'
import TeCommonBadgeReskilling from '~/components/Te/TeCommon/Badge/Reskilling/TeCommonBadgeReskilling.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faJava } from '@awesome.me/kit-65d95819ce/icons/classic/brands'
import { faChevronUp, faChevronDown } from '@awesome.me/kit-65d95819ce/icons/classic/solid'

const options = {
  async setup() {
    return {
      faJava,
      faChevronUp,
      faChevronDown,
    }
  },
    props: {
    beginsAt: {
      type: Date,
      default: null,
    },
    closesAt: {
      type: Date,
      default: null,
    },
  },
  data() {
    return {
      isActive: false,
    }
  },
  components: {
    TeCourseCoverTimeSpan,
    TeCommonBadgeReskilling,
    FontAwesomeIcon,
  },
}

export default defineNuxtComponent(options)
</script>

<style scoped>
.te-bg-java-image {
  background-image: linear-gradient(
    to top,
    rgba(173, 98, 5, .75),
    rgba(248, 152, 32, .75)
  ),
    url('~/assets/images/Te/TeCourse/Java/Cover/java-servlet.jpg');
}
</style>
